import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LicensesDashboard from "../components/Licenses/LicensesDashboard";

import { fetchLicenses } from "../store/licenses-actions";
import { licensesActions }  from "../store/licenses-slice";

export default function Licenses() {
  const isLoading = useSelector((state) => state.ui.licensesLoading);
  const licenses = useSelector((state) => state.licenses.list);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchLicenses());
    return () => dispatch(licensesActions.resetSelected());
  }, [dispatch]);

  return (
    <LicensesDashboard
      licenses={licenses}
      loading={isLoading}
      density="standard"
      mode="licenses"
      height={350}
    />
  );
}
